import React from "react";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: theme.palette.background.default,
    paddingTop: theme.spacing(2),
    position: "relative",
  },
  footerGradient: {
    bottom: 0,
    left: 0,
    right: 0,
    height: 5,
    position: "absolute",
    background:
      "linear-gradient(90deg, rgba(204,48,69,1) 0%, rgba(234,96,165,1) 20%, rgba(245,225,124,1) 40%, rgba(79,173,91,1) 60%, rgba(50,152,196,1) 80%, rgba(175,145,189,1) 100%)",
  },
}));

const MobileFooter = ({ children }) => {
  const classes = useStyles();

  return (
    <footer className={classes.footer}>
      {children}
      <span className={classes.footerGradient} />
    </footer>
  );
};

export default MobileFooter;
